import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function CreatorProtectedRoute() {
  const [state, setState] = useState({ loading: true, allowed: false });
  const location = useLocation();

  useEffect(() => {
    const controller = new AbortController();
    fetch(`${process.env.REACT_APP_API_URL}/me`, {
      credentials: "include",
      signal: controller.signal,
    })
      .then(async (response) => {
        if (!response.ok) return { allowed: false };
        const user = await response.json();
        return { allowed: user.can_manage_blog === true };
      })
      .then(({ allowed }) => setState({ loading: false, allowed }))
      .catch((error) => {
        if (error.name !== "AbortError") setState({ loading: false, allowed: false });
      });
    return () => controller.abort();
  }, []);

  if (state.loading) return <div className="creator-loading">Sitzung wird geprüft …</div>;
  if (!state.allowed) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}
